import script from "./ExperiencesView.vue?vue&type=script&setup=true&lang=js"
export * from "./ExperiencesView.vue?vue&type=script&setup=true&lang=js"

import "./ExperiencesView.vue?vue&type=style&index=0&id=67f35426&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67f35426"]])

export default __exports__